enum RecordsOption {
  BOOKING = 'BOOKING',
  ORDER = 'ORDER',
  LOYALTY = 'LOYALTY',
}

export default RecordsOption;
